import React, { useState, useEffect } from 'react';
import { View, Text as RNText, TouchableOpacity } from 'react-native';
import Text from '../../../../common/component/CustomTextComponent';
import { catClient } from '../../../../common';
import { gql, useQuery, useLazyQuery } from '@apollo/client';
import { FONT_FAMILY, THEME_COLORS } from '../../../../common/styles';
import CustomSelectV2 from "../../../../common/component/CustomSelect/CustomSelectV2";
import { CustomSelect } from '../../../../common/component';
import moment from "moment";

const FuelTypeFilter = (props: {
    onChange: (obj: any) => void;
    values: any[];
}) => {

    const { onChange, values } = props;

    return (
        <CustomSelect
            labelField={"name"}
            isLabelVisible={true}
            valueField={"value"}
            multi={true}
            options={FUEL_TYPES}
            height={50}
            isClearVisible={true}
            backgroundColor={THEME_COLORS.white}
            onChange={onChange}
            values={values}
            searchBy={""}
            label={'Fuel Type'}
            rowHeight={80}
            width={120}
            fieldName={"Fuel"}
        />
    )
}

const MakeTypeFilter = (props: {
    onChange: (obj: any) => void;
    values: any[];
    options: any[];
}) => {

    const { onChange, values, options } = props;

    return (
        <CustomSelect
            labelField={"displayName"}
            isLabelVisible={true}
            valueField={"value"}
            multi={true}
            options={options}
            height={30}
            isClearVisible={true}
            backgroundColor={THEME_COLORS.white}
            onChange={onChange}
            values={values}
            searchBy={""}
            label={'Make Type'}
            rowHeight={80}
            width={120}
            fieldName={"Make"}
        />
    )
}

const YearTypeFilter = (props: {
    onChange: (obj: any) => void;
    values: any[];
    options: any[];
}) => {

    const { onChange, values, options } = props;

    return (
        <CustomSelect
            labelField={"name"}
            valueField={"id"}
            isLabelVisible={true}
            options={options}
            isClearVisible={true}
            onChange={onChange}
            values={values}
            rowHeight={80}
            multi={true}
            label={'Year'}
            height={50}
            searchBy={""}
            width={120}
            fieldName={"Year"}
            backgroundColor={THEME_COLORS.white}
        />
    )
}

const MAKE_LIST_QUERY = gql`
query GetMakeList{
    getMakeList{
        id
        makeName
      }
}
`;

const MMVY_LIST_QUERY = gql`
    query getMakeModelVariantYearCache($search: String, $filters: [FilterInputType!], $perPage: Int){
        getMakeModelVariantYearCache(search:$search, perPage: $perPage, filters: $filters){
            paginator{
                numPages
                totalItems
                perPage
                currentPage
            }
            data{
                id
                displayName
                engineType
                variantName
                dateStart
                dateEnd
                modelName
            }
        }
    }
`;

const GET_MAPPED_MMVYS = gql`
  query getMappedMmvys($variantId: String!, $search: String, $filters: [FilterInputType!], $perPage: Int) {
    getMappedMmvys(variantId: $variantId, search:$search, filters: $filters, perPage: $perPage) {
      data {
        id
        displayName
        engineType
        variantName
        dateStart
        dateEnd
        modelName
      }
      paginator{
        numPages
        totalItems
        perPage
        currentPage
      }
    }
  }
`;

interface SelectedMmvyIds {
    id: string,
    isVerified: boolean,
}
interface IMakeModelVariantYearSelectProps {
    onSelect: (mmvydata: any) => void;
    selectedMmvyIds?: SelectedMmvyIds[];
    singleSelect?: boolean;
    multi?: boolean;
    showCustomHeader?: boolean;
    fuelFilterValue?: any;
    makeFilterValue?: any;
    yearFilterValue?: any;
    clearVal?: boolean;
    variantId?: string;
    mapped?: boolean;
    width?: number|string;
    backgroundColor?: string;
    isLabelVisible?: boolean;
    isRequired?: boolean;
    style?:any;
    prefilledMmvyIds?: string[];
    preventPrefilledDeselection?: boolean;
}

const FUEL_TYPES = [{
    id: 'petrol',
    name: 'Petrol',
    value: 'Petrol'
}, {
    id: 'diesel',
    name: 'Diesel',
    value: 'Diesel'
}, {
    id: 'cng',
    name: 'CNG',
    value: 'CNG'
}, {
    id: 'hybrid',
    name: 'Hybrid',
    value: 'Hybrid'
}, {
    id: 'electric_motor',
    name: 'Electric Motor',
    value: 'Electric Motor'
}];

const MakeModelVariantYearSelectV2 = (props: IMakeModelVariantYearSelectProps) => {

    let YEAR_TYPES = [];
    let MAKE_TYPES = [];

    const { fuelFilterValue, makeFilterValue, yearFilterValue, clearVal, variantId = '', mapped = false, selectedMmvyIds ,width,backgroundColor,isLabelVisible,isRequired,style} = props;

    const checkForMappedMmvy = mapped && variantId;


    const [getMmvyList, { data, loading, error, refetch }] = useLazyQuery(mapped ? GET_MAPPED_MMVYS : MMVY_LIST_QUERY, {
        variables: {
            perPage: 9999,
            variantId
        },
        client: catClient,
        fetchPolicy: mapped ? "no-cache" : "cache-first"
    });

    const { data: makeData, loading: makeLoading, error: makeError } = useQuery(MAKE_LIST_QUERY, {
        variables: {
            perPage: 9999
        },
        client: catClient,
        fetchPolicy: "cache-first"
    });

    const [loaded, setLoaded] = useState(false);
    const [fuelFilterValues, setFuelFilterValues] = useState([]);
    const [yearFilterValues, setYearFilterValues] = useState([]);
    const [makeFilterValues, setMakeFilterValues] = useState([]);
    let options = [];
    if (checkForMappedMmvy) options = data?.getMappedMmvys?.data
    else if (mapped === false) options = data?.getMakeModelVariantYearCache?.data

    if (options && props.prefilledMmvyIds && props.prefilledMmvyIds.length > 0) {
        const prefilledSet = new Set(props.prefilledMmvyIds);
        const prefilledOptions = options.filter(option => prefilledSet.has(option.id));
        const nonPrefilledOptions = options.filter(option => !prefilledSet.has(option.id));
        options = [...prefilledOptions, ...nonPrefilledOptions];
    }

    const showAlertMsg = (msg) => {
        setTimeout(() => {
            alert(msg);
        }, 700)
    }

    useEffect(() => {
        if (mapped === false || variantId) getMmvyList().then((resp) => {
            let mmvyList = resp?.data?.getMappedMmvys?.data;
            if (mmvyList?.length === 0) showAlertMsg('The Spinny variant ID exists in the system but hasn’t been mapped with any Spare ID, please contact the catalogue team to proceed further')
        }).catch(() => { });
        if (mapped && !variantId) showAlertMsg('Spinny Variant ID does not exist, please contact catalogue team to proceed further');
    }, []);

    useEffect(() => {
        setFuelFilterValues(
            !!fuelFilterValue && fuelFilterValue.length ? fuelFilterValue : []
        );
        setMakeFilterValues(
            !!makeFilterValue && makeFilterValue.length ? makeFilterValue : []
        );
        setYearFilterValues(
            !!yearFilterValue && yearFilterValue.length ? yearFilterValue : []
        );
    }, [fuelFilterValue, makeFilterValue, yearFilterValue]);

    useEffect(() => {
        if (!loaded) {
            setLoaded(true);
        }
    }, [data, selectedMmvyIds])

    useEffect(() => {
        if (options?.length === 1 && props.onSelect && checkForMappedMmvy && selectedMmvyIds?.length === 0) props.onSelect(options)
    }, [data])

    if (error || loading || !data) return (<View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        {mapped && !variantId ?
            <Text>Variant Id not found</Text>
            :
            <Text>Loading...</Text>
        }
    </View>);


    const getYear = (date) => {
        return !!date ? new Date(date).getFullYear() : new Date().getFullYear();
    }

    if (makeData && !makeLoading && !makeError) {
        MAKE_TYPES = makeData.getMakeList.map(item => ({ id: item.id, displayName: item.makeName, value: item.makeName }));
    }

    if (data && !loading && !error) {
        let yearData = [];
        let mmvyList = [];
        if (checkForMappedMmvy) mmvyList = data?.getMappedMmvys?.data
        else if (mapped === false) mmvyList = data?.getMakeModelVariantYearCache?.data
        let startYearArr = mmvyList?.map(item => getYear(item.dateStart)).sort();
        yearData.push(startYearArr[0]);
        let endYearArr = mmvyList?.map(item => getYear(item.dateEnd)).sort();
        yearData.push(endYearArr[endYearArr.length - 1]);

        for (let i = yearData[0]; i <= yearData[1]; i++) {
            YEAR_TYPES.push({
                id: i.toString(),
                name: i.toString(),
                value: i.toString()
            })
        }
    }

    return <CustomSelectV2 options={options}
        rowHeight={80}
        {...(backgroundColor && { backgroundColor })}
        {...(width && { width })}
        virtualized={true}
        isLabelVisible={isLabelVisible ?? true}
        {...(style && { style })}
        hideSelectField
        isRequired={isRequired ?? true}
        multi={props.multi}
        isClearVisible={true}
        filterObj={{ fuelFilterValues, yearFilterValues, makeFilterValues }}
        filterHandler={(options, searchText, filterObj) => {
            const { fuelFilterValues, yearFilterValues } = filterObj;
            if (fuelFilterValues.length) {
                options = options?.filter(obj => {
                    return fuelFilterValues.map(o => o.value.toLowerCase()).includes(obj.engineType.toLowerCase())
                })
            }
            if (yearFilterValues.length) {
                options = options?.filter(obj => {
                    return yearFilterValues.some(item => (getYear(obj.dateStart) <= parseInt(item.value, 10)) && (getYear(obj.dateEnd) >= parseInt(item.value, 10)));
                })
            }
            if (makeFilterValues.length) {
                options = options?.filter(obj => {
                    return makeFilterValues.map(o => o.value.split(" ")[0].toLowerCase()).includes(obj.displayName.split(" ")[0].toLowerCase())
                })
            }
            return options;
        }}
        header={!!props.showCustomHeader ? (<View style={{
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 5
        }}>
            <MakeTypeFilter
                options={MAKE_TYPES}
                values={makeFilterValues}
                onChange={(val) => {
                    setMakeFilterValues(val)
                }}
            />

            <FuelTypeFilter values={fuelFilterValues}
                onChange={(val) => {
                    setFuelFilterValues(val)
                }}
            />
            <YearTypeFilter
                options={YEAR_TYPES}
                values={yearFilterValues}
                onChange={(val) => {
                    setYearFilterValues(val)
                }}
            />
        </View>) : null}
        renderItem={({ option }) => {
            const isVerified = !!selectedMmvyIds?.find?.(val => !!(val?.id === option?.id && val?.isVerified));
            const isSelected = !!selectedMmvyIds?.find?.(val => val?.id === option?.id)
            const isPrefilled = props.prefilledMmvyIds?.includes(option?.id) || false;
            const isProtected = props.preventPrefilledDeselection && isPrefilled;

            return (
                <View style={{ display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: 'center' }}>
                    <TouchableOpacity 
                        style={{ 
                            flex: '4', 
                            width: '350px',
                            opacity: isProtected ? 0.6 : 1
                        }}
                        disabled={
                            selectedMmvyIds?.[0]?.id === '3131' || 
                            selectedMmvyIds?.[0]?.modelName?.toLowerCase?.() === 'universal' ||
                            isProtected
                        }
                        onPress={() => {
                            if (isProtected && isSelected) {
                                return;
                            }
                            
                            let values = []
                            if (isSelected) {
                                values = selectedMmvyIds?.filter?.(val => val?.id !== option?.id);
                            } else {
                                values = [...selectedMmvyIds, { id: option?.id, isVerified: false }];
                            }
                            if (props.onSelect) {
                                props.onSelect(values);
                            }
                        }}>
                            <View style={{display: 'flex',flexDirection: 'row', gap:'0.5rem'}}>
                                <input
                                    readOnly={true}
                                    type="checkbox"
                                    checked={isSelected}
                                    style={{
                                        cursor: isProtected ? 'not-allowed' : 'pointer'
                                    }}
                                />
                            <View style={{
                                flexDirection: "column", flexGrow: 0, flexShrink: 1,
                                width: '100%',
                                marginRight: 10,
                                justifyContent: "flex-start"
                            }}>
                                <Text
                                    fontSize={"medium"}
                                    type_of_six={"three_six"}
                                    style={{
                                        marginHorizontal: 5,
                                        marginVertical: 10,
                                        // width: '80%',
                                        flexWrap: "wrap",
                                        flexShrink: 1,
                                        flexGrow: 0,
                                    }}
                                >
                                    {option.displayName}
                                </Text>
                                <View style={{ flexDirection: "row", justifyContent: "flex-start" }}>
                                    <Text fontSize={"small"}
                                        style={{ width: 70 }}
                                        type_of_six={"two_six"}>
                                        {!!option.dateStart ? moment(option.dateStart).format('MM-YYYY').toString() : "N/A"}
                                    </Text>
                                    <View style={{ width: 20, height: 5 }}></View>
                                    <Text fontSize={"small"}
                                        style={{ width: 70 }}
                                        type_of_six={"two_six"}>
                                        {!!option.dateEnd ? moment(option.dateEnd).format('MM-YYYY').toString() : "N/A"}
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </TouchableOpacity>
                    <View style={{ flex: '1' }}>
                        <RNText style={{ marginEnd: 3, fontFamily: FONT_FAMILY?.primary, fontSize: 12, color: 'black' }}>Verified</RNText>
                        <TouchableOpacity style={{ width: 40, height: 20, marginStart: 3, borderRadius: 10, backgroundColor: isVerified ? 'green' : '#7D7D7D', zIndex: 10, opacity: (selectedMmvyIds?.[0]?.id === '3131' || selectedMmvyIds?.[0]?.modelName?.toLowerCase?.() === 'universal') ? 0.4 : 1 }}
                            disabled={selectedMmvyIds?.[0]?.id === '3131' || selectedMmvyIds?.[0]?.modelName?.toLowerCase?.() === 'universal'}
                            onPress={(e) => {
                                let filteredValue = selectedMmvyIds?.filter?.(val => val?.id !== option?.id)
                                if (isVerified) {
                                    props?.onSelect?.([...filteredValue, { id: option?.id, isVerified: false }])
                                }
                                else if (!isVerified) {
                                    props?.onSelect?.([...filteredValue, { id: option?.id, isVerified: true }])
                                }
                            }}
                        >
                            <View style={{ position: 'absolute', width: 20, height: 20, left: isVerified ? 20 : 0, borderRadius: 10, borderWidth: 0.5, borderColor: isVerified ? 'green' : '#7D7D7D', backgroundColor: '#F0F0F0' }} />
                        </TouchableOpacity>
                    </View>
                </View >
            )
        }}
        fieldName={"Make Model Variant"}
        searchBy={"displayName"}
        valueField={"id"}
        values={options?.filter(item => !!props.selectedMmvyIds.filter(i=>i.id === item.id).length)}
        selectedIdObj={props.selectedMmvyIds.length ? props.selectedMmvyIds:[]}
        labelField={"displayName"}
        clearAllOnPress={() => {
            if (props.preventPrefilledDeselection && props.prefilledMmvyIds && props.prefilledMmvyIds.length > 0) {
                const prefilledItems = props.selectedMmvyIds?.filter(item => 
                    props.prefilledMmvyIds?.includes(item.id)
                ) || [];
                props?.onSelect?.(prefilledItems);
            } else {
                props?.onSelect?.([]);
            }
        }}
        universalOnPress={() => {
            if (selectedMmvyIds?.[0]?.id !== '3131') {
                props?.onSelect?.([{ displayName: " Universal  ", engineType: "", id: "3131", modelName: "Universal", isVerified: true }])
            } else {
                props?.onSelect?.([])
            }
        }}
        selectAllOnPress={(values) => {  
            props?.onSelect?.(values)
        }}
    />
}

export default MakeModelVariantYearSelectV2;
